import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepbystepWrapper as Wrapper } from '../Wrapper'

import { LifeInsuranceApplicationProps } from '../container'

const styles = require('./styles.scss')

export const ApplicationStepDateOfBirth: React.SFC<LifeInsuranceApplicationProps> = (props) => {
  React.useEffect(() => {
    props.setIsBeforeRouterQuestions(true)
  }, [])

  return (
    <Wrapper backToPreview={true} {...props}>
      <StepTitle>What’s your date of birth?</StepTitle>
      <ApplicationField
        product={Product.LifeInsurance}
        field={Fields.DateOfBirth}
        onEnter={props.onContinue}
        styles={styles.formRow}
      />
    </Wrapper>
  )
}
